export default __webpack_public_path__ + "static/media/playstor.65472b18.svg";